export default __webpack_public_path__ + "static/media/insta01.ad27c1e2.webp";